const accountDropdown = () => {
  $(() => {
    function sendRequest(uri) {
      $.ajax({
        url: uri,
        dataType: 'script',
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: () => {
          $('.page-header-dropdown-instructors').jScrollPane();
        },
        error: () => {
          $('.page-header-dropdown-instructors').jScrollPane();
        },
      });
    }

    $(
      '.page-header-main-nav-button, .page-header-mobile-dropdown-nav, .page-header-account-toggle',
    ).on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const btn = $(e.currentTarget);
      const dropdown = $(btn.data('dropdown'));
      $('.page-header-main-nav-button').removeClass('active');

      if (dropdown.is(':visible')) {
        dropdown.hide();
        $('.page-header-dropdown').removeClass('open');
        $('.page-header-dropdown-tags').hide();
        $('.page-header-dropdown, .page-header-dropdown-account').hide();
        return;
      }

      $('.page-header-dropdown, .page-header-dropdown-account').hide();
      $('.page-header-dropdown').removeClass('open');
      $('.page-header-dropdown-tags').hide();

      if ($(btn).hasClass('page-header-main-nav-button')) {
        const btnOffset = btn.offset();
        const btnWidth = btn.outerWidth();
        const btnHeight = btn.outerHeight();
        $(btn).toggleClass('active');

        dropdown.show();

        const dropWidth = dropdown.outerWidth();
        const dropHeight = dropdown.outerHeight();

        const winWidth = $(window).width();
        const winHeight = $(window).height();
        const scrollTop = $(window).scrollTop();

        let top = 16 + btnHeight + 8;
        let left = btnOffset.left + btnWidth / 2 - dropWidth / 2;

        if (left < 8) left = 8;

        if (left + dropWidth > winWidth - 8) {
          left = winWidth - dropWidth - 8;
        }

        const spaceBelow = winHeight + scrollTop - (btnOffset.top + btnHeight);
        const spaceAbove = btnOffset.top - scrollTop;

        if (spaceBelow < dropHeight && spaceAbove > dropHeight) {
          top = btnOffset.top - dropHeight;
        }

        dropdown.css({
          top,
          left,
        });
      } else {
        dropdown.show();
      }

      $('.menu-scroll-pane').jScrollPane();
    });

    $('.page-header-dropdown-search-input').on('input', (e) => {
      const q = e.target.value;
      const url = new URL(`${window.location.origin}/instructors`);
      url.searchParams.delete('filter');
      url.searchParams.set('filter', q);
      url.searchParams.set('top_nav', true);
      const api = $('.page-header-dropdown-instructors').data('jsp');
      api.destroy();

      sendRequest(url.toString());
    });

    $('.page-header-dropdown-categories-item').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const btn = $(e.currentTarget);
      const category = $(btn.data('category'));

      if (category.is(':visible')) {
        category.hide();
        $('.page-header-dropdown').removeClass('open');
        return;
      }

      $('.page-header-dropdown-tags').hide();
      $('.page-header-main-nav-button').removeClass('active');

      category.show();
      $('.page-header-dropdown').addClass('open');
      $('.menu-scroll-pane').jScrollPane();
    });

    $('.page-header-mobile-button').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const btn = $(e.currentTarget);
      const dropdown = $(btn.data('dropdown'));

      if (dropdown.is(':visible')) {
        dropdown.hide();
        btn.removeClass('open');
        $('body').removeClass('mobile-menu-open');
        $('.page-header-dropdown, .page-header-dropdown-account').hide();
        return;
      }

      $('body').addClass('mobile-menu-open');
      btn.addClass('open');
      $('.page-header-mobile-dropdown-content').show();
      dropdown.show();
    });

    $('.page-header-dropdown-back').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const btn = $(e.currentTarget);
      const dropdown = $(btn.data('dropdown'));

      $('.page-header-dropdown, .page-header-dropdown-tags, .page-header-dropdown-account').hide();

      dropdown.show();

      $('.menu-scroll-pane').jScrollPane();
    });

    $(document).on('click', (e) => {
      const dropdown =
        $(e.target).closest('.page-header-dropdown')[0] || $('.page-header-dropdown')[0];
      const target = $(e.target)[0];
      if (dropdown && !jQuery.contains(dropdown, target)) {
        $('.page-header-dropdown, .page-header-dropdown-account').hide();
        $('.page-header-dropdown').removeClass('open');
        $('.page-header-dropdown-tags').hide();
        $('.page-header-main-nav-button').removeClass('active');
      }
    });
  });
};

export default accountDropdown;
